'use strict';
import {AudioNotificationService} from './AudioNotificationService';
import {NotificationService} from './NotificationService';


const angular = require('angular');

module.exports = angular
  .module('app.core-utilities.notifications', [])
  .service('FileStackNotificationsService', require('./FileStackNotificationsService.js'))
  .service(AudioNotificationService.SERVICE_NAME, AudioNotificationService)
  .service(NotificationService.SERVICE_NAME, NotificationService);



// WEBPACK FOOTER //
// ./src/js/core-utilities/notifications/index.js